import { render, staticRenderFns } from "./InssForm.vue?vue&type=template&id=b7e9a76a&scoped=true"
import script from "./InssForm.vue?vue&type=script&lang=js"
export * from "./InssForm.vue?vue&type=script&lang=js"
import style0 from "./InssForm.vue?vue&type=style&index=0&id=b7e9a76a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e9a76a",
  null
  
)

export default component.exports